module.exports = __webpack_public_path__ + "classroom-color-round.png";